import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import des traductions
import fr from './locales/fr.json';
import en from './locales/en.json';
import it from './locales/it.json';
import de from './locales/de.json';
import es from './locales/es.json';
import ar from './locales/ar.json';

const resources = {
  fr: {
    translation: fr
  },
  en: {
    translation: en
  },
  it: {
    translation: it
  },
  de: {
    translation: de
  },
  es: {
    translation: es
  },
  ar: {
    translation: ar
  }
};

i18n
  // Détection automatique de la langue
  .use(LanguageDetector)
  // Intégration avec React
  .use(initReactI18next)
  // Configuration
  .init({
    resources,
    
    // Langue par défaut
    lng: 'fr',
    fallbackLng: 'fr',
    
    // Langues supportées
    supportedLngs: ['fr', 'en', 'it', 'de', 'es', 'ar'],
    
    // Configuration de détection
    detection: {
      // Ordre de détection de la langue
      order: [
        'localStorage', // Préférence utilisateur sauvegardée
        'navigator', // Langue du navigateur
        'htmlTag', // Balise html lang
        'path', // URL path
        'subdomain' // Sous-domaine
      ],
      
      // Cache dans localStorage
      caches: ['localStorage'],
      
      // Clé de stockage
      lookupLocalStorage: 'titaton-language',
    },
    
    interpolation: {
      escapeValue: false // React échappe automatiquement
    },
    
    // Pour le développement
    debug: process.env.NODE_ENV === 'development',
    
    // Namespace par défaut
    defaultNS: 'translation',
    ns: ['translation'],
    
    // Configuration avancée
    react: {
      // Utiliser les Suspense boundaries
      useSuspense: false,
      // Bind i18n instance
      bindI18n: 'languageChanged',
      // Bind i18n store
      bindI18nStore: '',
      // Options pour les composants Trans
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
    }
  });

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
});

export default i18n;